import StatusError from './StatusError';

export default class Status401Error extends StatusError {}
